import {
  ChangeDetectionStrategy, Component, ElementRef, EventEmitter,
  Input, OnDestroy, OnInit, Output, ViewChild
} from "@angular/core";
import { Observable, Subject, Subscription } from "rxjs";
import { filter, map, share, switchMap } from "rxjs/operators";
import { FileProgress } from "./file-progress";
import { SelectFileService } from "./select-file.service";

@Component({
    selector: "app-select-file",
    templateUrl: "./select-file.component.html",
    styleUrls: ["./select-file.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SelectFileComponent implements OnInit, OnDestroy {
  @ViewChild("fileInput")
  inputReference: ElementRef;

  @Input()
  prompt: string = "Choose file";
  
  @Input() 
  disabled: boolean = false;

  @Input() 
  tooltip: string = '';

  @Output()
  fileParsed = new EventEmitter<string | ArrayBuffer>();

  @Output()
  fileSelected = new EventEmitter<File>();

  progress$: Observable<FileProgress>;
  isLoading$: Observable<boolean>;
  selectedFile: Subject<File>;
  subscription: Subscription;

  constructor(private fileService: SelectFileService) {}

  ngOnInit(): void {
    this.selectedFile = new Subject();

    this.progress$ = this.selectedFile.pipe(
      switchMap((file) => this.fileService.readFile(file)),
      share()
    );

    this.isLoading$ = this.progress$.pipe(
      map((result) => result.status !== "Done")
    );

    this.subscription = this.progress$
      .pipe(filter((result) => result.status === "Done"))
      .subscribe((result) => this.fileParsed.emit(result.content));
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  selectFile() {
    if (this.disabled) {
      return;
    }

    this.inputReference.nativeElement.click();
  }

  onFileSelected(event) {
    const file = (event.target as HTMLInputElement).files[0];
    this.inputReference.nativeElement.value = null;
    this.selectedFile.next(file);
    this.fileSelected.emit(file);
  }
}
